module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Coffee2-5074e108af423b1c0e00d502d356ae12.svg";